module.exports = __webpack_public_path__ + "static/media/nyk-logo.7bea0d63.png";